export const GLOBAL_EVENTS = {
  openSnackbar: "global:openSnackbar",
  toggleOpenLoading: "global:toggleOpenLoading",
};

export const PROFILE_EVENTS = {
  updateProfile: "profile:updateProfile",
};
